<template>
    <div class="date-picker">
        <input type="date" class="form-control text-center text-lg-left" :class="{ 'disabled-input': disabled }" ref="datePicker" v-model="mutableValue" />
    </div>
</template>

<script>
import { localeToSelect } from '../../common/flatpickrlocalizer';
import lang from '../../../shared/mixins/lang';
import flatpickr from 'flatpickr';
import moment from 'moment';
require('flatpickr/dist/themes/light.css');
require('../../../../../stylesheets/vendor/flatpickr/themes/light.css');

export default {
    mixins: [lang],
    props: {
        value: {
            required: true,
            default: null,
        },
        minimumDate: {
            type: String,
        },
        displayFormat: {
            type: String,
            default: 'M j, Y',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            picker: null,
            mutableValue: this.value,
            focusedInput: null,
            pickUpLabelElement: null,
            dropOffLabelElement: null,
        };
    },
    watch: {
        //workaround for disabled inputs not updating across siblings
        disabled() {
            if (!this.disabled) {
                $(this.$refs.datePicker).siblings('.disabled-input').removeClass('disabled-input');
            }
        },
        mutableValue(newValue) {
            this.$emit('input', newValue);
            this.$emit('dateSelected', newValue);
        },
        value(newValue) {
            this.picker && this.picker.setDate(newValue, true);
        },
        minimumDate(newValue) {
            if (this.picker) {
                this.picker.set('minDate', newValue);

                const newDate = moment(newValue);

                if (moment(this.value).isBefore(newDate)) {
                    this.mutableValue = newDate.add(1, 'days').toDate();
                }
            }
        },
    },
    methods: {
        transformDates(dates) {
            return dates.map((date) => {
                return moment(date).format('YYYY-MM-DD');
            });
        },
        config() {
            let config = {
                altInput: true,
                minDate: moment().startOf('day').toDate(),
                defaultDate: this.displayValue,
                altFormat: this.displayFormat,
                position: 'center',
                locale: localeToSelect,
            };

            return config;
        },
        open() {
            this.picker && this.picker.open();
        },
        focusFirst() {
            $(this.secondInput).removeClass('focused');
            $(this.$refs.datePicker).siblings('.flatpickr-input').addClass('focused');
            $(this.dropOffLabelElement).removeClass('active');
            $(this.pickUpLabelElement).addClass('active');

            this.focusedInput = 'first';
        },
        focusSecond() {
            $(this.secondInput).addClass('focused');
            $(this.$refs.datePicker).siblings('.flatpickr-input').removeClass('focused');
            $(this.pickUpLabelElement).removeClass('active');
            $(this.dropOffLabelElement).addClass('active');

            this.focusedInput = 'second';
        },
        unfocusBoth() {
            $(this.secondInput).removeClass('focused');
            $(this.$refs.datePicker).siblings('.flatpickr-input').removeClass('focused');

            this.focusedInput = null;
        },
        insertLabels() {
            const $calendar = $(this.picker.calendarContainer);

            this.dropOffLabelElement = $(`
        <div class="date-picker-help-text date-picker-help-text-dropoff">
          <span>${this.trans('booking-process.search.dropoff_date_help_text_label')}</span>
        </div>
      `).prependTo($calendar);
            this.pickUpLabelElement = $(`
        <div class="date-picker-help-text date-picker-help-text-pickup">
          <span>${this.trans('booking-process.search.pickup_date_help_text_label')}</span>
        </div>
      `).prependTo($calendar);
        },
    },
    mounted() {
        if (!this.picker) {
            flatpickr.l10ns.default.firstDayOfWeek = 1;

            this.picker = flatpickr(this.$refs.datePicker, this.config());

            this.insertLabels();
        }
    },
    beforeDestroy() {
        if (this.picker) {
            this.picker.destroy();
            this.picker = null;
        }
    },
};
</script>
<style lang="scss">
.date-picker {
    input {
        min-height: 100%;
    }

    .disabled-input {
        pointer-events: none;
    }
}
</style>
